import en from './en';
import fr from './fr';

export { en, fr };
